<script setup lang="ts">
import CreateWebinar from '@/components/CreateWebinar.vue'
import { formatToHumanReadable } from '@/utils'
import { useWebinarsStore } from '@/stores/webinars'

const webinarsStore = useWebinarsStore()
const init = async () => {
  await webinarsStore.fetch()
}
init()
</script>

<template>
  <main>
    <h2>Webinars</h2>
    <RouterView />

    <el-table :data="webinarsStore.webinars" style="width: 100%; margin: 1em 0">
      <el-table-column prop="date" label="Date">
        <template #default="scope">
          <RouterLink :to="{ query: { ...$route.query, webinar: scope.row.id } }">
            {{ formatToHumanReadable(scope.row.date) }}
          </RouterLink>
        </template>
      </el-table-column>
      <el-table-column prop="language" label="Language" />

      <el-table-column prop="code" label="Code" />

      <el-table-column label="Participants">
        <template #default="scope">
          {{ scope.row.chatters.length }}
        </template>
      </el-table-column>
    </el-table>
    <CreateWebinar @created="init" />
  </main>
</template>
